import DimensionsBento from "@/components/dimensions-bento";
import EmptyState from "@/components/empty-state";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useApplicationByEdition } from "@/hooks/application-by-edition.hook";
import { useCurrentUserProfile } from "@/hooks/current-user-profile.hook";
import { useEditionById } from "@/hooks/edition-by-id.hook";
import { cn } from "@/lib/utils";
import { currentEditionIdAtom } from "@/store/edition-id.store";
import { Clock } from "iconsax-react";
import { useAtomValue } from "jotai";
import { FC, HTMLAttributes } from "react";
import ProgressSummaryCard from "./progress-summary-card";

type EditionDashboardProps = HTMLAttributes<HTMLDivElement>;
/**
 * Shows the dashboard for a edition, including the progress summary and dimensions bento.
 * Only visible when the edition is published and the application is approved.
 *
 */
const EditionDashboard: FC<EditionDashboardProps> = (props) => {
  const editionId = useAtomValue(currentEditionIdAtom);

  const { data: userProfile } = useCurrentUserProfile();

  const { data: edition } = useEditionById({
    companyId: userProfile?.companyId || "",
    editionId,
  });

  const { data: application, refetch: refetchApplication } =
    useApplicationByEdition({
      companyId: userProfile?.companyId || "",
      editionId,
    });

  const editionPublished =
    edition &&
    edition.status !== "TO_PUBLISH" &&
    application?.status === "APPROVED";

  if (editionPublished) {
    const showProgressCard = edition.type === "REGULAR";

    return application?.quizId ? (
      <div
        className={cn(
          "my-4 grid grid-cols-1 gap-4",
          showProgressCard && "lg:grid-cols-3",
          props.className,
        )}
      >
        {showProgressCard && (
          <ProgressSummaryCard
            companyId={application.company.id}
            applicationQuizId={application.quizId}
          />
        )}

        <DimensionsBento
          className={cn(showProgressCard && "lg:col-span-2")}
          companyId={application.company.id}
          applicationQuizId={application.quizId}
          showExtraInfo={false}
          gridStyle={showProgressCard ? "grid" : "compact"}
        />
      </div>
    ) : (
      <Card className="my-4">
        <CardContent className="py-12">
          <EmptyState
            className="mx-auto"
            icon={Clock}
            message="El cuestionario estará listo en unos segundos..."
          >
            <p className="mt-4 text-center">
              <Button onClick={() => refetchApplication()}>Actualizar</Button>
            </p>
          </EmptyState>
        </CardContent>
      </Card>
    );
  }
};

export default EditionDashboard;
